import { render } from "./ChartFactMarge.vue?vue&type=template&id=8a57b6b8&scoped=true"
import script from "./ChartFactMarge.vue?vue&type=script&lang=js"
export * from "./ChartFactMarge.vue?vue&type=script&lang=js"

import "./ChartFactMarge.vue?vue&type=style&index=0&id=8a57b6b8&scoped=true&lang=css"

import exportComponent from "/home/vovan/Документы/Projects/taho-crm-git/Taho-Front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8a57b6b8"]])

export default __exports__